export default {
  state: {
    bannerUrl: ''
  },
  mutations: {
    setBannerUrl (state, bannerUrl) {
      state.bannerUrl = bannerUrl
    }
  },
  actions: {}
}
